import React, { useEffect, useRef } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const AuthCallback = () => {
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const match = window.location.hash.match(/session_id=([^&]+)/);
    const run = async () => {
      if (match) {
        try {
          await axios.post(`${API}/auth/session`, { session_id: decodeURIComponent(match[1]) }, { withCredentials: true });
          window.location.replace("/");
          return;
        } catch (e) {
          const code = e?.response?.status === 403 ? "unauthorized" : "failed";
          window.location.replace(`/login?error=${code}`);
          return;
        }
      }
      window.location.replace("/");
    };
    run();
  }, []);

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#FBEEF0", color: "#5C162E", fontFamily: "'Cormorant Garamond', serif", fontSize: 26 }}>
      Signing you in…
    </div>
  );
};
